const MAX_LENGTH = 2048;
// eslint-disable-next-line no-control-regex
const CONTROL_CHARS = /[\u0000-\u001F\u007F]/;
const AUTH_LOOP = /^\/(login|signup)(?=$|[/?#])/i;

function rejects(candidate: string): boolean {
  if (!candidate.startsWith('/')) return true;
  if (candidate.length > 1 && (candidate[1] === '/' || candidate[1] === '\\')) return true;
  if (candidate.includes('\\')) return true;
  if (CONTROL_CHARS.test(candidate)) return true;
  if (AUTH_LOOP.test(candidate)) return true;
  return false;
}

/** Returns a path on this origin, or null for any attacker-controlled URL. */
export function safeReturnTo(value: unknown): string | null {
  if (typeof value !== 'string' || value.length === 0 || value.length > MAX_LENGTH) return null;
  if (rejects(value)) return null;

  let decoded: string;
  try {
    decoded = decodeURIComponent(value);
  } catch {
    return null;
  }
  if (rejects(decoded)) return null;

  try {
    const probe = new URL(value, 'https://sweetspot.invalid');
    if (probe.origin !== 'https://sweetspot.invalid') return null;
  } catch {
    return null;
  }
  return value;
}

const DEEP_LINK_HOSTS = new Set(['www.sweetspot.la', 'sweetspot.la']);

export function deepLinkPath(url: string): string | null {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }

  let candidate: string;
  if (parsed.protocol === 'sweetspot:') {
    candidate = `/${parsed.host}${parsed.pathname}${parsed.search}${parsed.hash}`.replace(/^\/{2,}/, '/');
  } else if (parsed.protocol === 'https:' && DEEP_LINK_HOSTS.has(parsed.hostname.toLowerCase())) {
    candidate = parsed.pathname + parsed.search + parsed.hash;
  } else {
    return null;
  }

  const safe = safeReturnTo(candidate);
  return safe && safe !== '/' ? safe : null;
}
